import { DEFAULT_INVALID, DEFAULT_REPLACE } from 'cyprus/constants';
import { FORMAT_TYPE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';
import { invalidNumber } from 'cyprus/utils';

export const formatRate = (value: FormatValue, options: FormatValueOptions): string => {
  const { format } = options;
  const ignore = options.ignore || [];
  const decimal = Number(options.decimal || 0);
  const number = Number(value);

  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidNumber(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  const negative = Math.sign(number) === -1;
  const abs = Math.abs(number);

  switch (format) {
    case FORMAT_TYPE.RATE: {
      // determine nearest decimal with max decimal passed in
      // ex. decimals = 2, 12.02321 => 12.02x
      // ex. decimals = 2, 12.2 => 12.2x
      // ex. decimals = 2, 12.000003 => 12x
      const rounded = Math.round(abs * Math.pow(10, decimal)) / Math.pow(10, decimal);
      return `${rounded}x`;
    }
    case FORMAT_TYPE.RATE_FIXED: {
      if (negative) {
        return `-${String(abs.toFixed(decimal))}x`;
      }
      return `${String(abs.toFixed(decimal))}x`;
    }
    default:
      return String(value || '');
  }
};
